import { sectionRenderer } from "@theme/section-renderer";
import { startViewTransition } from "@theme/utilities";

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.delay_load =
      this.getAttribute("data-load-delay") && this.getAttribute("data-load-delay") === "true"
        ? true
        : false;

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.delay_load) {
      this.init();
    } else {
      document.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}
customElements.define("main-carousel", MainCarousel);

class MainCollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filters_form = this.querySelector("form");
    this.events = [
      {
        el: this,
        event: "input",
        callback: this.inputHandler.bind(this),
      },
    ];
  }
  connectedCallback() {
    this.handleEventListeners("add");
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }
  handleEventListeners(type = "add") {
    for (const evt of this.events) {
      if (type === "add") {
        evt.el.addEventListener(evt.event, evt.callback);
      } else {
        evt.el.removeEventListener(evt.event, evt.callback);
      }
    }
  }
  inputHandler(e) {
    this.applyFilters();
  }
  async applyFilters() {
    this.classList.add("filters-loading");
    const filter_params = this.getFilterParams();
    const fetch_params = new URLSearchParams(filter_params);
    fetch_params.set("section_id", document.querySelector("#ResultsList").dataset.sectionId);

    try {
      const response = await fetch(`${window.location.pathname}?${fetch_params.toString()}`);
      const html = await response.text();
      const parsed_doc = new DOMParser().parseFromString(html, "text/html");
      const new_grid = parsed_doc.querySelector(".main-collection-grid");
      const current_grid = document.querySelector(".main-collection-grid");
      if (new_grid && current_grid) {
        current_grid.replaceWith(new_grid);
        this.updateHistory(filter_params);
      }
    } catch (error) {
      console.error("CollectionFilters: failed to fetch filtered products", error);
    } finally {
      this.classList.remove("filters-loading");
    }
  }
  getFilterParams() {
    const form_params = new URLSearchParams(new FormData(this.filters_form));
    const filter_params = new URLSearchParams();

    for (const [name, value] of form_params) {
      if (String(value).toLowerCase() !== "all") {
        filter_params.append(name, value);
      }
    }

    return filter_params;
  }
  updateHistory(params) {
    const url = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    history.pushState({}, "", url);
  }
}
customElements.define("main-collection-filters", MainCollectionFilters);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".mphus-faq__container").forEach((faq) => {
    faq.addEventListener("click", (e) => {
      const parentEl = e.currentTarget;
      const answerEl = parentEl.querySelector(".faq-answer");

      if (parentEl.classList.contains("q-active")) {
        parentEl.classList.remove("q-active");
        answerEl.style.height = "0px";
      } else {
        parentEl.classList.add("q-active");
        answerEl.style.height = answerEl.scrollHeight + "px";
      }
    });
  });
});

class VideoElement extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.poster = this.querySelector(".video-element__video-img");

    this.playVideo = this.playVideo.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleEnded = this.handleEnded.bind(this);
  }

  connectedCallback() {
    if (!this.video || !this.poster) return;

    this.poster.addEventListener("click", this.playVideo);

    this.video.addEventListener("play", this.handlePlay);
    this.video.addEventListener("pause", this.handlePause);
    this.video.addEventListener("ended", this.handleEnded);
  }

  disconnectedCallback() {
    this.poster?.removeEventListener("click", this.playVideo);

    this.video?.removeEventListener("play", this.handlePlay);
    this.video?.removeEventListener("pause", this.handlePause);
    this.video?.removeEventListener("ended", this.handleEnded);
  }

  playVideo() {
    this.video?.play();
  }

  handlePlay() {
    this.classList.add("is-playing");
  }

  handlePause() {
    this.classList.remove("is-playing");
  }

  handleEnded() {
    this.video.currentTime = 0;
    this.classList.remove("is-playing");
  }
}

customElements.define("video-element", VideoElement);

class UserManuals extends HTMLElement {
  constructor() {
    super();

    this.productMultipleManuals = this.querySelectorAll(".user-manual__multiple");
  }

  connectedCallback() {
    if (!this.productMultipleManuals) return;

    this.productMultipleManuals.forEach((product) => {
      product.addEventListener("click", () => {
        product.classList.add("open-menu");
      });
      const closeBtn = product.querySelector(".close");
      closeBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        console.log("hello");
        product.classList.remove("open-menu");
      });
    });
  }
}

customElements.define("user-manuals", UserManuals);
